import ToastHelper from "../../../../helpers/ToastHelper";
import XlsxHelper from "../../../../helpers/XlsxHelper";
import { Utils } from "../../../../utils/utils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

function FileInput(props) {
  // MARK: --- Params ---
  const {
    name,
    text,
    value,
    onChange,
    onBlur,
    onFocus,
    onSelectedFile,
    onRemovedFile,
    onSubmit,
    enableCheckValid,
    isValid,
    isTouched,
    feedbackText,
    fileName,
    buttonText,
    supportFileTypes,
    acceptContentFile,
  } = props;
  const [selectedFile, setSelectedFile] = useState(null);
  const [headerRow, setHeaderRow] = useState([]);
  const { isSuccess } = useSelector((state) => state.adminState);
  const isShowError =
    enableCheckValid && !isValid && isTouched && !_.isEmpty(feedbackText);
  // console.log({ value });
  // console.log({ enableCheckValid, isValid, isTouched, feedbackText });

  // MARK: --- Functions ---

  function checkDuplicate(arr1, arr2) {
    let result = true;
    arr1?.forEach((item) => {
      if (!arr2.includes(item)) {
        result = false;
      }
    });
    return result;
  }

  async function handleChange(e) {
    if (!_.isEmpty(value)) {
      URL.revokeObjectURL(value);
    }
    const files = e?.target?.files;
    if (files && files.length > 0) {
      const selectedFile = files[0];
      const headerRow = await XlsxHelper.get_header_row_by_file(selectedFile);
      const boolean = checkDuplicate(acceptContentFile, headerRow);
      if (!boolean) {
        ToastHelper.showError("File không đúng nội dung");
        return;
      }
      setSelectedFile(selectedFile);
      if (onSelectedFile) {
        onSelectedFile(selectedFile);
      }
      const fileUrl = URL.createObjectURL(selectedFile);
      // console.log({ fileUrl });
      if (onChange) {
        onChange(fileUrl);
      }
    }

    handleFocus();
  }

  function handleBlur() {
    if (onBlur) {
      onBlur();
    }
  }

  function handleFocus() {
    if (onFocus) {
      onFocus();
    }
  }

  function handleRemoveFile() {
    if (!_.isEmpty(value)) {
      URL.revokeObjectURL(value);
    }
    if (onChange) {
      onChange("");
    }
    setSelectedFile(null);
    if (onRemovedFile) {
      onRemovedFile();
    }
  }

  function handleViewDocumentFile() {
    if (!_.isEmpty(value)) {
      const fullUrl = Utils.getFullUrl(value);
      Utils.openInNewTab(fullUrl);
      console.log({ fullUrl });
    }
  }

  // MARK: --- Hooks ---

  useEffect(() => {
    if (isSuccess) {
      handleRemoveFile();
    }
  }, [isSuccess]);

  return (
    <div>
      <div className="">
        <label
          className="btn btn-light-primary btn-sm mb-0"
          data-action="change"
        >
          <div className="font-bold">{buttonText}</div>
          <input
            type="file"
            accept={supportFileTypes}
            onChange={handleChange}
            hidden
            onClick={(e) => {
              e.target.value = null;
            }}
          />
        </label>

        {isShowError && (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">{feedbackText}</div>
          </div>
        )}
        {!_.isEmpty(text) && (
          <span className="form-text text-muted mt-2">{text}</span>
        )}

        {(selectedFile || value) && (
          <div className="mt-2 max-w-[200px]">
            <div
              className="rounded mt-2 flex items-center justify-between"
              style={{
                backgroundColor: "#F3F6F9",
                padding: "0.5rem 1rem",
              }}
            >
              <div className="flex flex-col">
                <div
                  className="text-sm font-bold line-clamp-1"
                  style={{
                    color: "#7E8299",
                    wordBreak: "break-word",
                  }}
                >
                  {selectedFile ? selectedFile.name : fileName}
                </div>
                {selectedFile && (
                  <div className="text-sm font-bold text-muted">
                    {`${Utils.fileSizeInMB(selectedFile.size)} MB`}
                  </div>
                )}
              </div>
              <div className="flex items-center">
                <span
                  className="w-[25px] h-[25px] flex items-center justify-end cursor-pointer hover:text-green-700"
                  onClick={() => {
                    onSubmit();
                    handleRemoveFile();
                  }}
                >
                  <CheckOutlined />
                </span>
                <span
                  className="w-[25px] h-[25px] flex items-center justify-end cursor-pointer hover:text-red-600"
                  onClick={handleRemoveFile}
                >
                  <CloseOutlined />
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FileInput;
